import { render, staticRenderFns } from "./ItsBaseMater.vue?vue&type=template&id=25875fd3&scoped=true&"
import script from "./ItsBaseMater.vue?vue&type=script&lang=js&"
export * from "./ItsBaseMater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25875fd3",
  null
  
)

export default component.exports